(() => {
  function replaceChildren() {
    const childNodes = this.childNodes;
    while (childNodes.length) {
      childNodes[0].remove();
    }
    this.append(...arguments);
  }
  if (!Document.prototype.replaceChildren) Document.prototype.replaceChildren = replaceChildren;
  if (!DocumentFragment.prototype.replaceChildren) DocumentFragment.prototype.replaceChildren = replaceChildren;
  if (!Element.prototype.replaceChildren) Element.prototype.replaceChildren = replaceChildren;
})();
//# sourceMappingURL=Element.replaceChildren.js.map
